import { MoneySchema } from 'notable-common';
import { z } from 'zod';

// Request schemas (reused from flowMetric)
export const FlowMetricRequestSchema = z.object({
  flowIds: z.array(z.uuid()),
});
export type FlowMetricRequest = z.infer<typeof FlowMetricRequestSchema>;

export const AgentMetricRequestSchema = z.object({
  agentIds: z.array(z.uuid()),
});
export type AgentMetricRequest = z.infer<typeof AgentMetricRequestSchema>;

// Analytical metrics (BigQuery)
export const AnalyticalFlowMetricsSchema = z.object({
  dollarValueGenerated: MoneySchema.nullable(),
  utilizationDollars: MoneySchema.nullable(),
});

export type AnalyticalFlowMetrics = z.infer<typeof AnalyticalFlowMetricsSchema>;

export const AnalyticalFlowMetricResponseSchema = z.record(z.string(), AnalyticalFlowMetricsSchema);
export type AnalyticalFlowMetricResponse = z.infer<typeof AnalyticalFlowMetricResponseSchema>;

// Realtime metrics (PostgreSQL)
export const RealtimeAgentMetricsSchema = z.object({
  flowRunCount: z.number(),
  mostRecentFlowRunAt: z.string(),
});

export type RealtimeAgentMetrics = z.infer<typeof RealtimeAgentMetricsSchema>;

export const RealtimeAgentMetricResponseSchema = z.record(z.string(), RealtimeAgentMetricsSchema);
export type RealtimeAgentMetricResponse = z.infer<typeof RealtimeAgentMetricResponseSchema>;
